import Organization from '~/models/directories/Organization'

export default class CurrentOrganization extends Organization {
  static entity = 'currentorganization'

  static fields () {
    return super.fields()
  }
}
